import './styles/loader.scss';
import './styles/loader-contrast.scss';

export default function Loader({ extra_classes, style }) {
	return (
		<div className={`loader ${ extra_classes || "" }`} style={ style }>
			<div className="cssload-whirlpool"></div>
		</div>
	)
}